import React from 'react';
import Typed from 'react-typed';
import './header.css';

function Header(){
    return(
        <div className="me">
            <h1 className="period">About</h1>
        </div>
    )
}

export default Header